import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import {
  buttonName,
  createReffPartner,
  EditReffPartner
} from "../../locales/en";
import CommonModal from "./CommonModal";
import { generateReferralUrls } from "../../utils/referralUtils";
import { REFERRAL_USER_LENGTH_0 } from "../../utils/constants/appConstants";

export const EditReferralCodeModal = ({
  isOpen,
  toggle,
  referralUser,
  setReferralUser,
  errors,
  setErrors,
  referralUserCount
}) => {
  const [localCode, setLocalCode] = useState(referralUser.code || "");
  const handleChange = (e) => {
    const value = e.target.value;

    setLocalCode(value);

    setErrors((prev) => ({
      ...prev,
      code: ""
    }));
  };

  const handleSave = () => {
    const code = localCode.trim();

    if (!code) {
      setErrors((prev) => ({
        ...prev,
        code: EditReffPartner?.errMsg?.item2
      }));
      return;
    }

    const urls = generateReferralUrls(code);

    setReferralUser((prev) => ({
      ...prev,
      code,
      ...urls
    }));

    toggle();
  };

  const handleClose = () => {
    setErrors((prev) => ({
      ...prev,
      code: ""
    }));

    toggle();
  };

  useEffect(() => {
    if (isOpen) {
      setLocalCode(referralUser.code || "");
      setErrors((prev) => ({
        ...prev,
        code: ""
      }));
    }
  }, [isOpen, referralUser.code]);

  const isEditable = referralUserCount === REFERRAL_USER_LENGTH_0;

  const footerButtons = [
    {
      label: buttonName?.close,
      className: "btn btn-secondary",
      onClick: handleClose
    },
    ...(isEditable
      ? [
          {
            label: buttonName?.save,
            className: "btn btn-primary",
            onClick: handleSave
          }
        ]
      : [])
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={createReffPartner?.editReferralCode}
      footerButtons={footerButtons}
    >
      <div className="row">
        <div className="col-12">
          <div className="mb-3">
            <div
              className={`${Modalstyle.modalInputwrap} ${Modalstyle.passwordModalWrap}`}
            >
              <label htmlFor="code">{createReffPartner?.referralCode}</label>

              <div className={Modalstyle.formInput}>
                <input
                  type="text"
                  name="code"
                  value={localCode}
                  onChange={handleChange}
                  disabled={!isEditable}
                />

                {errors.code && (
                  <div className="text-danger small">{errors.code}</div>
                )}

                {!isEditable && (
                  <div className="text-danger small">
                    {EditReffPartner?.editReferralText_1}
                    {` ${referralUserCount} `}
                    {EditReffPartner?.editReferralText_2}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

EditReferralCodeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  referralUser: PropTypes.object.isRequired,
  setReferralUser: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  referralUserCount: PropTypes.number
};
